import axios from 'axios';
import { API_BASE_URL, handleApiError } from './_apiBase';
import { TenantInfo } from '../types/billing';

// ── Huvudadmin: kunder och byte av kund ──────────────────────────────────────

/** Kundlistan. Sidorna har lite olika bild av en kund, därför generisk. */
export const fetchTenants = async <T = TenantInfo>(): Promise<T[]> => {
    try { return (await axios.get<T[]>(`${API_BASE_URL}/superuser/tenants`)).data; }
    catch (e) { return handleApiError(e, 'Hämta kundlistan'); }
};

/**
 * Engångskod för att ta med inloggningen till en kunds adress. Token skickas med
 * uttryckligen eftersom anropet kan ske innan axios fått sin standardrubrik.
 */
export const requestSuperuserHandoff = async (token: string): Promise<{ code: string }> => {
    try {
        return (await axios.post<{ code: string }>(`${API_BASE_URL}/superuser/su-handoff`, {}, { headers: { Authorization: `Bearer ${token}` } })).data;
    } catch (e) { return handleApiError(e, 'Byta kund'); }
};
